import { addSearchBoxInteractedTrackingEvent } from "@website/ticket-ui/common/helper/searchBoxInteractedTrackingEvents";
import { useCallback, useEffect, useState } from "react";

export const usePassengerCount = (value: {
  adult: number;
  child: number;
  infant: number;
}) => {
  const [temporaryPassengerCount, setTemporaryPassengerCount] = useState<{
    adult: number;
    child: number;
    infant: number;
  }>({
    adult: 1,
    child: 0,
    infant: 0
  });

  const [passengerCount, setPassengerCount] = useState(temporaryPassengerCount);

  useEffect(() => {
    if (value.adult) {
      setTemporaryPassengerCount(value);
      setPassengerCount(value);
    }
  }, [value.adult, value.child, value.infant]);

  const onSubmitPassengerCount = useCallback(() => {
    setTemporaryPassengerCount((state) => {
      const { adult = 1, child = 0, infant = 0 } = state || {};
      const numberOfPassengers = adult + child + infant;

      addSearchBoxInteractedTrackingEvent({
        number_of_passengers: numberOfPassengers,
        adult_count: adult,
        child_count: child,
        infant_count: infant
      });
      setPassengerCount(state);
      return state;
    });
  }, []);

  const onChangeAdult = useCallback((value: number) => {
    setTemporaryPassengerCount((state) => ({
      ...state,
      adult: value
    }));
  }, []);

  const onChangeChild = useCallback((value: number) => {
    setTemporaryPassengerCount((state) => ({
      ...state,
      child: value
    }));
  }, []);

  const onChangeInfant = useCallback((value: number) => {
    setTemporaryPassengerCount((state) => ({
      ...state,
      infant: value
    }));
  }, []);

  const { adult, child, infant } = temporaryPassengerCount;

  const total = adult + child + infant;
  const remain = 9 - total;
  const remainNotAdult = Math.min(remain, adult * 3 - child - infant);

  const adultMax = adult + remain;
  const adultMin = Math.max(Math.ceil((child + infant) / 3), infant, 1);
  const childMax = child + remainNotAdult;
  const childMin = 0;
  const infantMax = infant + Math.min(remainNotAdult, adult - infant);
  const infantMin = 0;

  const list = [
    {
      increaseDisabled: adult >= adultMax,
      decreaseDisabled: adult <= adultMin,
      title: "تعداد بزرگسال",
      subtitle: "12 سال به بالا",
      value: adult,
      onChange: onChangeAdult
    },
    {
      increaseDisabled: child >= childMax,
      decreaseDisabled: child <= childMin,
      title: "تعداد کودک",
      subtitle: "2 تا 12 سال",
      value: child,
      onChange: onChangeChild
    },
    {
      increaseDisabled: infant >= infantMax,
      decreaseDisabled: infant <= infantMin,
      title: "تعداد نوزاد",
      subtitle: "0 تا 2 سال",
      value: infant,
      onChange: onChangeInfant
    }
  ];

  return {
    passengerCountTitle: "تعداد مسافر",
    passengerCountResult: `${
      passengerCount.adult + passengerCount.child + passengerCount.infant
    } مسافر`,
    passengerCountList: list,
    passengerCount,
    onSubmitPassengerCount
  };
};
